// The Wilds: fun games, bought with gems, kept forever.

import { h, clear } from '@kit/dom';
import { GAMES, lockInfo } from '../registry';
import { getSave, update, subscribe } from '../state';
import { go } from '../router';
import { topBar, toast, banner } from '../ui';
import { artImg } from '@kit/assets';
import { play as sound } from '@kit/audio';

export function wildsScreen(root: HTMLElement) {
  const bar = topBar('The Wilds', { back: 'hub' });
  const intro = h('p.muted.pad', null, 'Fun games live here. Unlock them with gems you earned in the Academy.');
  const explore = h('div', { style: { padding: '0 16px 10px' } }, h('button.btn.primary.block', { onclick: () => go('wilds-map') }, 'Explore the Wilds on foot'));
  const list = h('div.stack', { style: { padding: '0 16px 24px' } });
  root.append(bar);
  const ban = banner('scene.wilds'); if (ban) root.append(ban);
  root.append(intro, explore, list);

  function render() {
    clear(list);
    const s = getSave();
    for (const g of GAMES.filter(g => g.category === 'fun')) {
      const lock = lockInfo(g, s);
      const price = lock.needGems ?? 0;
      list.append(h('div.card', { style: { borderLeft: '8px solid var(--fun)' } },
        h('div.row', null, artImg(`icon.${g.id}`, 56), h('h3', null, g.title)),
        h('p.muted.small', null, g.blurb),
        h('div.row', { style: { marginTop: '10px' } },
          lock.unlocked
            ? h('button.btn.primary', { onclick: () => go(`play/${g.id}`) }, 'Play')
            : h('button.btn' + (s.gems >= price ? '.primary' : ''), {
              disabled: s.gems < price,
              onclick: () => {
                if (getSave().gems < price) return;
                update(x => { x.gems -= price; x.totals.gemsSpent += price; x.owned.push(g.id); });
                sound('chime');
                toast(`${g.title} unlocked!`);
              },
            }, `Unlock for ${price} `, h('span.dot.gem', { style: { display: 'inline-block' } })),
          !lock.unlocked && s.gems < price ? h('span.small.muted', null, `You have ${s.gems}. Earn ${price - s.gems} more.`) : null,
        ),
      ));
    }
    list.append(h('p.center.muted.small', { style: { marginTop: '12px' } }, 'More games join the Wilds as you grow.'));
  }
  render();
  const un = subscribe(render);
  return () => un();
}
